import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appCustomDatePicker]',
  standalone: true,
})
export class CustomDatePickerDirective implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit() {
    const input = this.el.nativeElement;

    // Aplicar estilos para ocultar el icono por defecto
    input.style.position = 'relative';

    // Crear el contenedor del icono personalizado
    const iconContainer = document.createElement('div');
    iconContainer.style.position = 'absolute';
    iconContainer.style.right = '10px';
    iconContainer.style.top = '50%';
    iconContainer.style.transform = 'translateY(-50%)';
    iconContainer.style.pointerEvents = 'none';

    // Crear el icono personalizado
    const icon = document.createElement('img');
    icon.src = './assets/calendar.svg'; // Asegúrate de tener este icono
    icon.style.width = '25px';
    icon.style.height = '25px';

    // Agregar el icono al contenedor
    iconContainer.appendChild(icon);
    input.parentNode.insertBefore(iconContainer, input.nextSibling);
  }
}
